import SurveysUpdate from './SurveysUpdate'
export {SurveysUpdate}
export default SurveysUpdate
